<template>
  <div v-if="!isProduction" class="s-environment-display">
    {{ environment.toUpperCase() }}
  </div>
</template>

<script setup lang="ts">
/**
 * Displays current environment badge in non-production environments.
 * Shows environment name (DEVELOP, ACCEPTANCE, etc.) in red badge. Hidden in production.
 */
import { computed } from "vue";

import { getEnv } from "@solvari/utils";

const environment = computed(() => getEnv().config.envBE);
const isProduction = computed(() => environment.value === "production");
</script>

<style scoped lang="postcss">
.s-environment-display {
  @apply h-fit w-fit rounded bg-danger-600 p-2 text-sm text-white;
}
</style>
